import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

// Website Components
import Navbar from './components/common/Navbar';
import Footer from './components/common/Footer';
import Home from './components/website/Home';
import About from './components/website/About';
import Academics from './components/website/Academics';
import Admissions from './components/website/Admissions';
import Gallery from './components/website/Gallery';
import Contact from './components/website/Contact';
import NewsMedia from './components/website/NewsMedia';
import Departments from './components/website/Departments';
import Disclosure from './components/website/Disclosure';

// Admin Components
import AdminLogin from './components/admin/AdminLogin';
import AdminDashboard from './components/admin/AdminDashboard';
import TimetableManagement from './components/admin/TimetableManagement';

// Student Components
import StudentLogin from './components/student/StudentLogin';
import StudentDashboard from './components/student/StudentDashboard';
import Profile from './components/student/Profile';
import FeePayment from './components/student/FeePayment';
import Notices from './components/student/Notices';
import MarksCard from './components/student/MarksCard';
import StudyMaterials from './components/student/StudyMaterials';

// Protected Route Components
const AdminRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  if (!token || user.role !== 'admin') {
    return <Navigate to="/vsw-admin-portal" replace />;
  }
  return children;
};

const StudentRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  if (!token || user.role !== 'student') {
    return <Navigate to="/vsw-student-portal" replace />;
  }
  return children;
};

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 3000,
            style: { background: '#363636', color: '#fff' },
          }}
        />

        <Routes>
          {/* Public Website Routes */}
          <Route path="/" element={<><Navbar /><Home /><Footer /></>} />
          <Route path="/about" element={<><Navbar /><About /><Footer /></>} />
          <Route path="/academics" element={<><Navbar /><Academics /><Footer /></>} />
          <Route path="/news-media" element={<><Navbar /><NewsMedia /><Footer /></>} />
          <Route path="/departments" element={<><Navbar /><Departments /><Footer /></>} />
          <Route path="/gallery" element={<><Navbar /><Gallery /><Footer /></>} />
          <Route path="/contact" element={<><Navbar /><Contact /><Footer /></>} />
          <Route path="/disclosure" element={<><Navbar /><Disclosure /><Footer /></>} />

          {/* Admissions (standalone layout) */}
          <Route path="/admissions" element={<Admissions />} />

          {/* Admin Routes */}
          <Route path="/vsw-admin-portal" element={<AdminLogin />} />
          <Route path="/vsw-admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
          <Route path="/admin/timetable" element={<AdminRoute><TimetableManagement /></AdminRoute>} />

          {/* Student Routes */}
          <Route path="/vsw-student-portal" element={<StudentLogin />} />
          <Route path="/vsw-student" element={<StudentRoute><StudentDashboard /></StudentRoute>} />
          <Route path="/student/profile" element={<StudentRoute><Profile /></StudentRoute>} />
          <Route path="/student/fees" element={<StudentRoute><FeePayment /></StudentRoute>} />
          <Route path="/student/notices" element={<StudentRoute><Notices /></StudentRoute>} />
          <Route path="/student/marks" element={<StudentRoute><MarksCard /></StudentRoute>} />
          <Route path="/student/study-materials" element={<StudentRoute><StudyMaterials /></StudentRoute>} />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;